import styled from 'styled-components'

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 12px;
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: visible;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  }
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`

export const IconContainer = styled.div<{ $color?: string }>`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: ${(props) => props.$color || 'rgba(0, 173, 230, 0.1)'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const MetricValue = styled.span`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 4px;
  display: block;
`

export const MetricLabel = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
  display: flex;
  align-items: center;
  gap: 4px;
`

export const MetricHighlight = styled.span<{
  $type: 'success' | 'warning' | 'danger' | 'info'
  $textAlign?: 'left' | 'center' | 'right'
}>`
  font-size: 14px;
  font-weight: 600;
  text-align: ${(props) => props.$textAlign || 'left'};
  color: ${(props) =>
    props.$type === 'success'
      ? '#00B341'
      : props.$type === 'warning'
        ? '#FF9500'
        : props.$type === 'danger'
          ? '#FF3B30'
          : '#007AFF'};
`

export const ProgressBar = styled.div`
  width: 100%;
  height: 6px;
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: 3px;
  overflow: hidden;
  margin: 12px 0;
`

export const ProgressFill = styled.div<{
  $percentage: number
  $color?: string
}>`
  height: 100%;
  width: ${(props) => props.$percentage}%;
  background: ${(props) => props.$color || '#00ADE6'};
  border-radius: 3px;
  transition: width 0.3s ease;
`
